<div class="row">

    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
        <label>Mode de tarification :
            <span class="required_champs">*</span>
        </label>
        <ng-select [clearable]="false" (change)="check_if_is_famille()"
            [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
            name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
            [closeOnSelect]="true" >
            <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{
                item?.libelle }}
            </ng-option>
        </ng-select>
    </div>

    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
        style="padding-left: 5px; padding-right: 5px">
        <label>Nombre pers. par famille:
            <span class="required_champs">*</span>
        </label>
        <br>
        <input disabled class="form-control custom-input"
            [(ngModel)]="itemToSave.nombre_personnes_famille"
            name="nombre_personnes_famille" autocomplete="off" type="text"
            mask="separator" />
    </div>
    <div class="col col-md-12">
        <div class="table-responsive">
            <table class="table table-condensed table-hover">
                <thead>
                    <tr class="custom-table-head">
                        <th> <a style="cursor: pointer;margin-top: 5px;" (click)="refreshList()"
                                        
                            title="Actualiser">
                            <i class="fa fa-redo-alt"></i></a>
                            Statut</th>
                        <th>Prime</th>
                        <th>Plafond</th>
                        <th>Age min</th>
                        <th>Age max</th>
                        <th>Nombre autorisé</th>
                        <th>Nombre suppl. autorisé</th>
                        <th>Surprime</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="cursor: pointer;"
                        *ngFor="let item of itemsStatutInitialized; let indice = index">
                        <td style="font-weight: 700;">{{item.libelle}}</td>
                        <td
                            [class.isNotConsidered]="is_tarif_famille && item.codification !='A'">
                            <input (input)="onInputChange($event)" (keyup)="get_prime_par_famille()" class="form-control custom-input" autocomplete="off"
                                [(ngModel)]="item.prime" autocomplete="off" type="text"
                                mask="separator"
                                [ngModelOptions]="{standalone: true}" />
                        </td>
                        <td>
                            <input (input)="onInputChange($event)" (keyup)="get_plafond_par_famille()" class="form-control custom-input"
                                [(ngModel)]="item.plafond" autocomplete="off"
                                type="text" mask="separator"
                                [ngModelOptions]="{standalone: true}" />
                        </td>
                        <td>
                            <input (input)="onInputChange($event)" class="form-control custom-input"
                                [(ngModel)]="item.age_min" autocomplete="off"
                                type="text" mask="separator"
                                [ngModelOptions]="{standalone: true}" />
                        </td>

                        <td><input (input)="onInputChange($event)" class="form-control custom-input"
                                [(ngModel)]="item.age_max" autocomplete="off"
                                type="text" mask="separator"
                                [ngModelOptions]="{standalone: true}" />
                        </td>
                        <td><input (input)="onInputChange($event)" [disabled]="item.codification =='A'"
                                (keyup)="get_nombre_par_famille();get_prime_par_famille();get_plafond_par_famille()"
                                class="form-control custom-input"
                                [(ngModel)]="item.nombre_autorise" autocomplete="off"
                                type="text" mask="separator"
                                [ngModelOptions]="{standalone: true}" /></td>

                        <td><input (input)="onInputChange($event)" [disabled]="item.codification =='A'"
                                [class.isNotConsidered]="item.nombre_autorise == 0"
                                class="form-control custom-input"
                                [(ngModel)]="item.nombre_supplementaire_autorise"
                                autocomplete="off" type="text" mask="separator"
                                [ngModelOptions]="{standalone: true}" />
                        </td>
                        <td>
                            <input (input)="onInputChange($event)" [disabled]="item.codification =='A'"
                                [class.isNotConsidered]="item.nombre_autorise == 0"
                                class="form-control custom-input"
                                [(ngModel)]="item.surprime_si_supplementaire"
                                autocomplete="off" type="text" mask="separator"
                                [ngModelOptions]="{standalone: true}" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</div>